var am = (function (module) {
    module.AddressAutoCompleter = function () {
        this._eType = "Google";
        this._oGeocoder = undefined;
        this._oInputField = undefined;
        this._oOptions = undefined;
        this._oProvider = undefined;
        this._autocompleterListener = undefined;
        this._addressSuggestionsDiv = undefined;
    };

    module.AddressAutoCompleter.prototype.init = function (oGeocoder, oInput, oOptions) {
        this._eType = oGeocoder.getType();
        this._oGeocoder = oGeocoder;
        this._oInputField = oInput;
        this._oOptions = oOptions;

        switch (this._eType) {
            case "Google":
                this._oProvider = new google.maps.places.Autocomplete(this._oInputField, this._oOptions);
                this._addressSuggestionsDiv = $('.pac-container .pac-logo');
                break;
            default:
                this._oProvider = {};
                this._addressSuggestionsDiv = $('<div class=".pac-container .pac-logo hidden">');
                $('body').append(this._addressSuggestionsDiv);
                break;
        }
    };

    module.AddressAutoCompleter.prototype.addListener = function (callback) {
        var self = this;
        switch (this._eType) {
            case "Google":
                this._autocompleterListener = this._oProvider.addListener('place_changed', callback);
                break;
            case "Geoportail":
                $('#am-address-search-field').on('keyup', function () {
                    var $searchField = $(this);
                    var sVal = $searchField.val();
                    if (sVal.length > 2) {
                        self._oGeocoder.getPostalAddressSuggestions(sVal, 5).then(function(oResA){
                            if (oResA.length > 0) {
                                // Fill the list of suggestions
                                var $children = self._addressSuggestionsDiv.find('.pac-item');
                                for (var iChild = 0; iChild < Math.min($children.length, oResA.length); ++iChild) {
                                    $children.eq(iChild).html(oResA[iChild]);
                                }
                                for (iChild = $children.length; iChild < oResA.length; ++iChild) {
                                    self._addressSuggestionsDiv.append($('<div class="pac-item">' + oResA[iChild] + '</div>'));
                                }
                                for (iChild = oResA.length; iChild < $children.length; ++iChild) {
                                    self._addressSuggestionsDiv.find('.pac-item:last-child').remove();
                                }

                                // Reposition the list of suggestions
                                var searchFieldPosition = $searchField.offset();
                                self._addressSuggestionsDiv.css({
                                    width: $searchField.width(),
                                    position: 'absolute',
                                    top: searchFieldPosition.top + $searchField.outerHeight(),
                                    left: searchFieldPosition.left,
                                    'z-index': 99999
                                });
                                self._addressSuggestionsDiv.removeClass('hidden');
                            }
                        }).catch(function(answer) {
                            self._addressSuggestionsDiv.html('');
                        });
                    } else {
                        self._addressSuggestionsDiv.html('');
                    }
                });

                this._autocompleterListener = function () {
                    console.log($(this).val());
                };

                /*$( "#am-address-search-field" ).autocomplete({
                  minLength: 1,
                  source: function(oReq, oResp) {
                    var sVal = $('#am-address-search-field').val();
                    self._oSearchController._oGeocoder.getPostalAddressSuggestions(sVal, 5, function(oResA, sStatus){
                      console.log(sStatus);
                      var oDataA = [];
                      if(sStatus === "OK"){
                        for(var n=0; n<oResA.length; n++) {
                          oDataA.push({label: oResA[n], value: oResA[n]});
                        }
                      }
                      oResp(oDataA);
                    });
                  },
                  messages: {
                    noResults: '',
                    results: function() {}
                  }
                });*/

                /*
                this._inputKeyUpListener  = function(oEvt){
                  var sVal = $('#am-address-search-field').val();
                  console.log("Key up: " + sVal);
                  self._oSearchController._oGeocoder.getPostalAddressSuggestions(sVal, 5, function(oResA, sStatus){
                    if(sStatus === "OK"){
                      if(oResA.length > 0){
                        $('#am-address-autocomplete').empty();
                        for(var n=0; n<oResA.length; n++) {
                          $("#am-address-autocomplete").append("<option value='" + oResA[n] + "'>" + oResA[n] + "</option>");
                        }
                      }
                    }
                  });
                };
                $('#am-address-search-field').bind('keyup', this._inputKeyUpListener);
                */

                break;
            default:
                break;
        }
    };

    module.AddressAutoCompleter.prototype.removeListener = function () {
        if (this._autocompleterListener) {
            switch (this._eType) {
                case "Google":
                    google.maps.event.removeListener(this._autocompleterListener);
                    break;
                case "Geoportail":
                    $('#am-address-search-field').unbind('change');
                    //$('#am-address-search-field').unbind('keyup');
                    break;
                default:
                    break;
            }
        }
    };

    module.AddressAutoCompleter.prototype.getProviderObj = function () {
        return this._oProvider;
    };

    return module;

})(am || {});

am.utils = (function (module) {
    'use strict';
    module.addressAutoCompleter = function (oGeocoder, oInput, oOptions) {
        var oCtrl = new am.AddressAutoCompleter();
        oCtrl.init(oGeocoder, oInput, oOptions);
        return oCtrl;
    };
    return module;
})(am.utils || {});